package com.milta.core.localization.translations.pl

import com.milta.core.localization.HomeStrings

internal val Home = HomeStrings(
    navTournee = "Trasa",
    navEcoDriving = "Eko jazda",
    navCommunity = "Społeczność",
    navRewards = "Nagrody",
    navHome = "Główna",
    navRoutes = "Trasy",
    navTeam = "Zespół",
    navProfile = "Profil",
)
